<template>
  <k-modal :show="showModal" @close="closeModal" class="assign-meeting-owner-modal">
  <template #header>
    <h3>Assign Meeting Owner</h3>
  </template>
  <template #body>
    <select-user
      v-model="meetingOwner"
      :default-meeting-owner="defaultMeetingOwner"
      @reset-meeting-owner="meetingOwner = $event">
    </select-user>
  </template>
    <template #footer>
      <button class="modal-return-button btn btn-default cancel-btn" @click="closeModal">Cancel </button>
      <button class="btn btn-success submit-btn" @click="assignMeetingOwner" :disabled="disableSubmit">
        Assign Meeting Owner
      </button>
    </template>
  </k-modal>
</template>

<style>
.assign-meeting-owner-modal .meeting-owner-body {
  margin-bottom: 15px;
}

.assign-meeting-owner-modal .user-selection-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.assign-meeting-owner-modal .user-selection-actions button.search-button {
  flex: 1;
}
</style>

<script>
import useGlobalStore from '@stores/global';
import KModal from '@base-components/k-modal.vue';
import SelectUser from './select-user.vue';

export default {
  components: {
    SelectUser,
    KModal,
  },

  props: {
    meeting: {
      type: Object,
      required: true,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      store: useGlobalStore(),
      meetingOwner: { },
    };
  },

  computed: {
    moduleMeetingId() {
      return this.meeting.module_meeting_id;
    },
    studentId() {
      return this.meeting.student_id;
    },
    disableSubmit() {
      return ['coach', 'data_mentor'].indexOf(this.meetingOwner.learner_support_type) === -1;
    },
    defaultMeetingOwner() {
      return {
        id: this.store.userId,
        full_name: this.store.userFullName,
        email: this.store.userEmail,
        avatar_url: this.store.avatarUrl,
        learner_support_type: this.store.learnerSupportType,
      };
    },
  },

  methods: {
    closeModal() {
      this.meetingOwner = this.defaultMeetingOwner;
      this.$emit('close');
    },
    assignMeetingOwner() {
      const payload = {
        meeting_owner_user_id: this.meetingOwner.id,
        learner_support_type: this.meetingOwner.learner_support_type,
      };
      const loggerPayload = {
        meetingOwnerUserId: this.meetingOwner.id,
        moduleMeetingId: this.moduleMeetingId,
        studentId: this.studentId,
      };
      this.$logger.info('Assigning meeting owner', loggerPayload);
      this.$Loading.start();
      this.$http.put(`/api/curriculum/admin/meeting/${this.moduleMeetingId}/user/${this.studentId}/meeting_owner`, payload)
        .then(() => {
          this.$ktoast.success('Meeting owner assigned');
          this.$emit('update');
          this.closeModal();
        })
        .catch(err => {
          this.$logger.error('Error assigning meeting owner', loggerPayload, err);
          this.$ktoast.showError(err, true);
        }).then(() => {
          this.$Loading.finish();
        });
    },
  },
};

</script>
